// Array global para os pinos
window.sedesMarkers = [];

// Função auxiliar para desenhar pinos e ajustar o zoom (usada na busca por formulário)
function atualizarPinosSedesNoMapa(sedes) {
    if (!window.sedesMap || !sedes || !sedes.length) return;

    if (window.sedesMarkers) {
        window.sedesMarkers.forEach(marker => marker.setMap(null));
    }
    window.sedesMarkers = [];

    const bounds = new google.maps.LatLngBounds();

    sedes.forEach(sede => {
        if (sede.lat && sede.lng) {
            const pos = { lat: parseFloat(sede.lat), lng: parseFloat(sede.lng) };

            const marker = new google.maps.Marker({
                position: pos,
                map: window.sedesMap,
                title: sede.title,
                animation: google.maps.Animation.DROP
            });

            const infoWindow = new google.maps.InfoWindow({
                content: `
                    <div style="padding: 5px;">
                        <h4 style="margin: 0 0 5px 0; font-size: 14px;">${sede.title}</h4>
                        <p style="margin: 0; font-size: 12px; color: #555;">${sede.address}</p>
                    </div>
                `
            });

            marker.addListener('click', function() {
                infoWindow.open(window.sedesMap, marker);
            });

            window.sedesMarkers.push(marker);
            bounds.extend(pos);
        }
    });

    window.sedesMap.fitBounds(bounds);

    if (sedes.length === 1) {
        google.maps.event.addListenerOnce(window.sedesMap, 'bounds_changed', function() {
            if (window.sedesMap.getZoom() > 15) {
                window.sedesMap.setZoom(15);
            }
        });
    }
}

// Função para desenhar pinos ao mover o mapa manualmente (sem alterar o zoom/centro)
function desenharPinosSemAlterarZoom(sedes) {
    if (!window.sedesMap || !sedes) return;

    if (window.sedesMarkers) {
        window.sedesMarkers.forEach(marker => marker.setMap(null));
    }
    window.sedesMarkers = [];

    sedes.forEach(sede => {
        if (sede.lat && sede.lng) {
            const pos = { lat: parseFloat(sede.lat), lng: parseFloat(sede.lng) };

            const marker = new google.maps.Marker({
                position: pos,
                map: window.sedesMap,
                title: sede.title,
                animation: google.maps.Animation.DROP
            });

            const infoWindow = new google.maps.InfoWindow({
                content: `
                    <div style="padding: 5px;">
                        <h4 style="margin: 0 0 5px 0; font-size: 14px;">${sede.title}</h4>
                        <p style="margin: 0; font-size: 12px; color: #555;">${sede.address}</p>
                    </div>
                `
            });

            marker.addListener('click', function() {
                infoWindow.open(window.sedesMap, marker);
            });

            window.sedesMarkers.push(marker);
        }
    });
}

// Função reutilizável para buscar sedes e atualizar o Swiper via AJAX
function atualizarListaSedesPorCoordenadas(lat, lng) {
    const containerGrid = document.querySelector('.sede-grid .swiper-wrapper');
    if (!containerGrid) return;

    containerGrid.style.opacity = '0.5';

    const formData = new FormData();
    formData.append('action', 'buscar_sedes_por_proximidade');
    formData.append('lat', lat);
    formData.append('lng', lng);

    fetch(sedes_ajax.ajax_url, {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(response => {
        containerGrid.style.opacity = '1';

        if (response.success) {
            containerGrid.innerHTML = response.data.html;

            // Reinicializa o Swiper
            if (typeof initSedesSwiper === 'function') {
                initSedesSwiper();
            }

            if (response.data.sedes) {
                desenharPinosSemAlterarZoom(response.data.sedes);
            }
        } else {
            containerGrid.innerHTML = `<p>${response.data.message}</p>`;
        }
    })
    .catch(error => {
        containerGrid.style.opacity = '1';
        console.error('Erro na atualização da busca:', error);
    });
}

export function initMaps() {

    // Referências dos elementos
    const mapElement = document.getElementById('mapa-sedes');
    const inputLocal = document.getElementById('input-busca-local');
    const inputLat = document.getElementById('search-lat');
    const inputLng = document.getElementById('search-lng');
    const formBusca = document.getElementById('form-busca-sedes');

    let userMarker;
    const defaultCenter = { lat: -23.55052, lng: -46.633308 };

    // 1. Inicializar o Mapa
    if (mapElement && typeof google !== 'undefined') {
        window.sedesMap = new google.maps.Map(mapElement, {
            zoom: 13,
            center: defaultCenter,
            mapTypeControl: false,
            streetViewControl: false
        });

        // Tenta obter a localização atual via GPS do navegador
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                function(position) {
                    const userPos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };

                    window.sedesMap.setCenter(userPos);

                    userMarker = new google.maps.Marker({
                        position: userPos,
                        map: window.sedesMap,
                        title: 'Sua localização atual',
                        icon: {
                            path: google.maps.SymbolPath.CIRCLE,
                            scale: 8,
                            fillColor: '#4285F4',
                            fillOpacity: 1,
                            strokeColor: '#FFFFFF',
                            strokeWeight: 3
                        }
                    });

                    if (inputLat && inputLng) {
                        inputLat.value = userPos.lat;
                        inputLng.value = userPos.lng;
                    }

                    if (formBusca) {
                        formBusca.dispatchEvent(new Event('submit'));
                    }
                },
                function(error) {
                    console.warn('Geolocalização não permitida ou indisponível:', error.message);
                }
            );
        }

        // Evento 'idle': Atualiza o carrossel quando o usuário arrasta/navega no mapa
        let mapMoveTimeout;
        window.sedesMap.addListener('idle', function() {
            clearTimeout(mapMoveTimeout);

            mapMoveTimeout = setTimeout(function() {
                const center = window.sedesMap.getCenter();
                const lat = center.lat();
                const lng = center.lng();

                if (inputLat && inputLng) {
                    inputLat.value = lat;
                    inputLng.value = lng;
                }

                atualizarListaSedesPorCoordenadas(lat, lng);
            }, 500);
        });
    }

    // 2. Google Places Autocomplete
    if (inputLocal && typeof google !== 'undefined') {
        const autocomplete = new google.maps.places.Autocomplete(inputLocal, {
            componentRestrictions: { country: 'br' },
            fields: ['geometry', 'formatted_address']
        });

        autocomplete.addListener('place_changed', function() {
            const place = autocomplete.getPlace();

            if (place.geometry) {
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();

                inputLat.value = lat;
                inputLng.value = lng;

                if (window.sedesMap) {
                    const newPos = { lat: lat, lng: lng };
                    window.sedesMap.setCenter(newPos);
                    window.sedesMap.setZoom(13);

                    if (userMarker) {
                        userMarker.setPosition(newPos);
                    } else {
                        userMarker = new google.maps.Marker({
                            position: newPos,
                            map: window.sedesMap,
                            title: 'Local pesquisado',
                            icon: {
                                path: google.maps.SymbolPath.CIRCLE,
                                scale: 8,
                                fillColor: '#4285F4',
                                fillOpacity: 1,
                                strokeColor: '#FFFFFF',
                                strokeWeight: 3
                            }
                        });
                    }
                }
            }
        });
    }

    // 3. PASSO 4: Envio simplificado do formulário de busca
    if (formBusca) {
        formBusca.addEventListener('submit', function(e) {
            e.preventDefault();

            const lat = inputLat ? inputLat.value : '';
            const lng = inputLng ? inputLng.value : '';

            if (!lat || !lng) {
                alert('Por favor, selecione uma cidade ou CEP válido na lista de sugestões.');
                return;
            }

            // Move o mapa para o local pesquisado (o evento 'idle' acionará a busca do carrossel automaticamente)
            const targetPos = { lat: parseFloat(lat), lng: parseFloat(lng) };
            window.sedesMap.setCenter(targetPos);
            window.sedesMap.setZoom(13);

            // Reseta o visual dos estados para "Todos" quando uma busca por texto é feita
        if (botoesEstado.length) {
            botoesEstado.forEach(b => b.classList.remove('active'));
            const btnTodos = document.querySelector('.btn-filtro-estado[data-estado-id="todos"]');
            if (btnTodos) btnTodos.classList.add('active');
        }
        });
    }

    // 4. Função para centralizar o mapa na sede clicada pelo card
    function focarSedeNoMapa(lat, lng, title) {
        if (mapElement && window.sedesMap) {
            const targetPos = { lat: parseFloat(lat), lng: parseFloat(lng) };

            mapElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

            window.sedesMap.setCenter(targetPos);
            window.sedesMap.setZoom(16);

            if (window.sedeActiveMarker) {
                window.sedeActiveMarker.setPosition(targetPos);
                window.sedeActiveMarker.setTitle(title);
            } else {
                window.sedeActiveMarker = new google.maps.Marker({
                    position: targetPos,
                    map: window.sedesMap,
                    title: title,
                    animation: google.maps.Animation.DROP
                });
            }
        }
    }

    // 5. Evento de clique nos botões "Ver no mapa" dos cards
    document.addEventListener('click', function(e) {
        const btn = e.target.closest('.btn-ver-no-mapa');
        
        if (btn) {
            e.preventDefault();
            const lat = btn.getAttribute('data-lat');
            const lng = btn.getAttribute('data-lng');
            const title = btn.getAttribute('data-title');

            if (lat && lng) {
                focarSedeNoMapa(lat, lng, title);
            }
        }
    });

    // Listener de clique nos botões dos Estados
const botoesEstado = document.querySelectorAll('.btn-filtro-estado');

botoesEstado.forEach(btn => {
    btn.addEventListener('click', function(e) {
        e.preventDefault();

        // Alterna a classe ativa visualmente
        botoesEstado.forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        const estadoId = this.getAttribute('data-estado-id');
        const containerGrid = document.querySelector('.sede-grid .swiper-wrapper');

        if (containerGrid) {
            containerGrid.style.opacity = '0.5';
        }

        const formData = new FormData();
        formData.append('action', 'filtrar_sedes_por_estado');
        formData.append('estado_id', estadoId);

        fetch(sedes_ajax.ajax_url, {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(response => {
            if (containerGrid) {
                containerGrid.style.opacity = '1';
            }

            if (response.success) {
                // 1. Atualiza o carrossel de cards
                containerGrid.innerHTML = response.data.html;

                if (typeof initSedesSwiper === 'function') {
                    initSedesSwiper();
                }

                // 2. Desenha os pinos no mapa e ajusta o enquadramento (zoom/centro)
                if (response.data.sedes && typeof atualizarPinosSedesNoMapa === 'function') {
                    atualizarPinosSedesNoMapa(response.data.sedes);
                }
            } else if (containerGrid) {
                containerGrid.innerHTML = `<p>${response.data.message}</p>`;
            }
        })
        .catch(error => {
            if (containerGrid) {
                containerGrid.style.opacity = '1';
            }
            console.error('Erro no filtro por estado:', error);
        });
    });
});

}

export function initSedesSwiper() {
    // 1. O Swiper DEVE ser instanciado no container principal (.sedes-grid ou .sede-grid)
    // NUNCA passe a .swiper-wrapper aqui!
    const swiperElement = document.querySelector('.sede-grid  .swiper') || document.querySelector('.sede-grid  .swiper');

    // Se o elemento não existir no DOM no momento da chamada, interrompe com segurança
    if (!swiperElement) {
        console.warn('Container do Swiper não encontrado no DOM.');
        return;
    }

    // 2. Se já existir uma instância rodando, destrói para evitar conflito de eventos
    if (window.sedesSwiper && typeof window.sedesSwiper.destroy === 'function') {
        window.sedesSwiper.destroy(true, true);
    }

    // 3. Cria a nova instância do Swiper usando o elemento HTML válido (swiperElement)
    window.sedesSwiper = new Swiper(swiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'progressbar'
        }
    });

    // 4. Garante que os limites e posições dos novos cards sejam recalculados
    setTimeout(function() {
        if (window.sedesSwiper && typeof window.sedesSwiper.update === 'function') {
            window.sedesSwiper.update();
        }
    }, 100);
}